@if (loading) {
<all-product-skeleton-loader></all-product-skeleton-loader>
} @else {
<div class="product-order-container">
  <div class="-main">
    <div class="-head">
      <h1>All Products</h1>
      @if (isSearchEnabled) {
      <div class="product-search-input-container">
        <lucide-icon name="search" class="product-search-icon" size="16"></lucide-icon>
        <input
          id="-product-search-input"
          [value]="searchTerm"
          (input)="onSearchChange($event)"
          type="text"
          placeholder="Search by product name & description"
          autocomplete="off" />
      </div>
      }
    </div>
    @if (!isResponsiveApplicable) {
    <section class="-left-content">
      @if (categoryData) {
      <app-category-sidebar [categoryData]="categoryDataWithCounts" (categorySelected)="onCategorySelection($event)">
      </app-category-sidebar>
      }
      <solution-finder-card [solutionFinderResponse]="meta['solution-finder']"></solution-finder-card>
    </section>
    }
    <section class="-right-content">
      @if (dataLoaded) {
      <section class="-sort-filter" [class.responsive-screen]="!isResponsiveApplicable">
        <section class="-multi-filter">
          @if (productTypeItems.length > 0) {
          <app-filter-combo-box
            filterId="product-filter"
            accessibleLabel="Product Type"
            [placeholder]="productTypePlaceholder"
            [items]="productTypeItems"
            [values]="productTypeValues"
            (selectionChange)="onFilterComboBoxChange('productType', $event)">
          </app-filter-combo-box>
          } @if (isResponsiveApplicable && categoryDataWithCounts) {
          <multi-select-dropdown
            #hierarchyCategoryDropdown
            id="category-filter"
            [buttonTitle]="categoryPlaceholder"
            [tree]="hierarchicalCategoryTree"
            [isHierarchicalData]="true"
            [showCounts]="false"
            [showClearButton]="true"
            [breakpointActive]="isResponsiveApplicable"
            (selectionChange)="onHierarchicalCategoriesChange($event)"
            (cleared)="onHierarchicalCategoriesCleared()">
          </multi-select-dropdown>
          } @if (businessTypeItems.length > 0) {
          <app-filter-combo-box
            filterId="business-filter"
            accessibleLabel="Business Type"
            [placeholder]="businessTypePlaceholder"
            [items]="businessTypeItems"
            [values]="businessTypeValues"
            (selectionChange)="onFilterComboBoxChange('businessType', $event)">
          </app-filter-combo-box>
          } @if (regionItems.length > 0) {
          <app-filter-combo-box
            filterId="region-filter"
            accessibleLabel="Region"
            [placeholder]="regionPlaceholder"
            [items]="regionItems"
            [values]="regionValues"
            (selectionChange)="onFilterComboBoxChange('region', $event)">
          </app-filter-combo-box>
          }
        </section>
        <section class="-results-header">
          @if (isAnyFilterApplied) {
          <span class="clear-filter" (click)="onClearFilter()">Clear Filters</span>
          }
          <p>{{ productDetails.length }} results</p>
        </section>
        @if (isResponsiveApplicable) {
        <section class="-solution-finder-responsive">
          <solution-finder-card [solutionFinderResponse]="meta['solution-finder']"></solution-finder-card>
        </section>
        }
      </section>
      } @if (dataLoaded && productDetails?.length === 0) {
      <div class="no-results-container">
        <div class="no-results-header">No results found</div>
        <div class="no-results-text">Try adjusting your filters or try a different keyword</div>
        <div class="-secondary-paragraph">
          Or try our
          <app-link to="/solutionfinder" class="no-results-link">Solution Finder</app-link>
        </div>
      </div>
      }
      <section class="-results-container">
        @for (product of productDetails; track trackByProductIdentity($index, product)) {
        <div class="card-wrapper">
          <app-card-category-product
            class="card-category"
            totype="title"
            [title]="product.productTitle"
            [to]="product.productTo || ''"
            [indicators]="product.indicators">
            <p>{{ product.productDescription }}</p>
            <span class="-product-pill">
              @if (showRegions) { @for (region of splitRegions(product.region); track region) {
              <wp-flag [name]="'flags/' + countryFlag(region)" [attr.aria-label]="region + ' flag'"> </wp-flag>
              } } @if (showTags) { @for (tag of product.tags; track tag) {
              <wp-chips state="neutral" contrast="contrast" [indicatorIcon]="false">
                {{ tag }}
              </wp-chips>
              } }
            </span>
          </app-card-category-product>
        </div>
        }
      </section>
    </section>
  </div>
  @if (body) {
  <content-viewer [content]="body" (docRendered)="handleDocRendered($event)"></content-viewer>
  }
</div>
}
